module.exports = __webpack_public_path__ + "img/down-zk-logo.5591940f.png";